import React from "react";
import { UserCog, Info, FileText, Receipt } from "lucide-react";
import TopBar from "../components/layout/TopBar";
import HelpTooltip from "../components/common/HelpTooltip";
import AccountantAccessPanel from "../components/commercialista/AccountantAccessPanel";
import DeclarationsSection from "../components/commercialista/DeclarationsSection";
import F24UploadsSection from "../components/commercialista/F24UploadsSection";
import { useAppState } from "../hooks/useAppState";

export default function CommercialitaPage() {
  const { user, darkMode, toggleDarkMode, isSynced } = useAppState();

  return (
    <div className={`min-h-screen transition-colors ${darkMode ? "bg-neutral-950 text-white" : "bg-neutral-50 text-neutral-900"}`}>
      <TopBar
        user={user}
        notificationsCount={0}
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
        onUploadLogo={() => {}}
        isSynced={isSynced}
      />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 pb-24">
        {/* Header */}
        <div className="mt-6 mb-6">
          <h1 className={`text-xl font-semibold flex items-center gap-2 ${darkMode ? "text-white" : "text-neutral-900"}`}>
            <UserCog className="w-5 h-5 text-forfy-500" />
            Commercialista
          </h1>
          <p className={`mt-1 text-sm ${darkMode ? "text-neutral-500" : "text-neutral-500"}`}>
            Condividi l'accesso con il tuo commercialista e gestisci dichiarazioni e F24
          </p>
        </div>

        <div className="space-y-6">
          {/* Sezione 1: Accesso Commercialista */}
          <div className={`rounded-2xl border p-6 ${darkMode ? "border-neutral-800 bg-neutral-900" : "border-neutral-200 bg-white"}`}>
            <div className="flex items-center gap-2 mb-4">
              <Info className={`w-5 h-5 ${darkMode ? "text-forfy-300" : "text-forfy-600"}`} />
              <h2 className={`text-sm font-semibold uppercase tracking-wide ${darkMode ? "text-white" : "text-neutral-900"}`}>
                Accesso Commercialista
              </h2>
              <HelpTooltip
                text={
                  "Il tuo commercialista potrà: ✓ Scaricare le fatture pagate ✓ Caricare dichiarazioni dei redditi ✓ Caricare F24 compilati. Non potrà modificare o eliminare i tuoi dati."
                }
                darkMode={darkMode}
              />
            </div>
            <AccountantAccessPanel darkMode={darkMode} />
          </div>

          {/* Sezione 2: Dichiarazioni dei Redditi */}
          <div className={`rounded-2xl border p-6 ${darkMode ? "border-neutral-800 bg-neutral-900" : "border-neutral-200 bg-white"}`}>
            <div className="flex items-center gap-2 mb-4">
              <FileText className={`w-5 h-5 ${darkMode ? "text-indigo-400" : "text-indigo-600"}`} />
              <h2 className={`text-sm font-semibold uppercase tracking-wide ${darkMode ? "text-white" : "text-neutral-900"}`}>
                Le tue Dichiarazioni dei Redditi
              </h2>
            </div>
            <DeclarationsSection darkMode={darkMode} />
          </div>

          {/* Sezione 3: F24 dal Commercialista */}
          <div className={`rounded-2xl border p-6 ${darkMode ? "border-neutral-800 bg-neutral-900" : "border-neutral-200 bg-white"}`}>
            <div className="flex items-center gap-2 mb-4">
              <Receipt className={`w-5 h-5 ${darkMode ? "text-emerald-400" : "text-emerald-600"}`} />
              <h2 className={`text-sm font-semibold uppercase tracking-wide ${darkMode ? "text-white" : "text-neutral-900"}`}>
                I tuoi F24
              </h2>
            </div>
            <F24UploadsSection darkMode={darkMode} />
          </div>
        </div>
      </main>
    </div>
  );
}
